
import { z } from "zod";

// Define Australian locations for dropdown
export const australianLocations = [
  "Sydney, NSW",
  "Melbourne, VIC",
  "Adelaide, SA",
  "Canberra, ACT",
  "Brisbane, QLD",
  "Perth, WA",
  "Hobart, TAS",
  "Darwin, NT"
];

export const formSchema = z.object({
  name: z.string().min(1, "Company name is required"),
  location: z.string().min(1, "Location is required"),
  bio: z.string().min(10, "Bio must be at least 10 characters").max(500, "Bio must be less than 500 characters"),
  staffSize: z.string().min(1, "Staff size is required"),
  logo: z.instanceof(File).optional(),
  website: z.string().url("Please enter a valid URL").or(z.string().length(0)).optional(),
  twitterUrl: z.string().url("Please enter a valid URL").or(z.string().length(0)).optional(),
  instagramUrl: z.string().url("Please enter a valid URL").or(z.string().length(0)).optional(),
  linkedinUrl: z.string().url("Please enter a valid URL").or(z.string().length(0)).optional(),
});

export type CompanyFormValues = z.infer<typeof formSchema>;
